<template>
  <div>
    <v-container fluid class="pa-8">
      <v-card class="px-5" outlined>
        <v-card-text>
          <div class="d-flex mb-4">
            <h2 class="custom-t">Search Results&nbsp;&nbsp;</h2>
            <h3 class="ml-2 mt-2">{{ totalGeneticCount }} records found</h3>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              right
              height="40"
              width="116"
              color="primary"
              @click="back()"
              >BACK</v-btn
            >
          </div>
          <div class="d-flex my-5">
            <v-btn
              v-if="totalGeneticCount > 1"
              outlined
              right
              height="40"
              :disabled="selected.length < 2"
              color="primary"
              @click="openDialog()"
              >COMPARE SELECTED</v-btn
            >
            <v-spacer></v-spacer>
            <!-- <v-btn
                            class="mx-2"
                            fab
                            small
                            outlined
                            color="primary"
                        >
                            <v-img src="/icons/download.svg"></v-img>
                        </v-btn>
                        <v-btn
                            class="mx-2"
                            fab
                            small
                            outlined
                            color="primary"
                        >
                            <v-icon > mdi-printer </v-icon>
                        </v-btn> -->
            <div class="pt-2 pr-2 black--text">
              {{ $t("geneticsAndBreeding.rowsPerPage") }}
            </div>
            <v-select
              style="max-width: 63px"
              v-model="options.itemsPerPage"
              dense
              :items="itemsPerPageOptions"
              class="mr-5"
            ></v-select>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="options.page <= 1"
              @click="tabletPageChange(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="options.page >= totalPages"
              @click="tabletPageChange(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
            <div class="py-1 title">
              {{ from }} - {{ to }} of {{ totalGeneticCount }}
            </div>
          </div>
          <v-alert v-model="alert" dismissible text outlined class="mr-5">
            <span class="red--text font-weight-bold">Note: </span>
            <span class="black--text"
              >Traits displayed in grey are under development, coming in Q2,
              2023.</span
            >
            <template v-slot:close>
              <v-btn icon small @click="alertClosed"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </template>
          </v-alert>
          <v-data-table
            :headers="headers"
            :items="GeneticData"
            item-key="id"
            show-select
            v-model="selected"
            :items-per-page="10"
            :loading="loading"
            loading-text="Loading... Please wait"
            :options.sync="options"
            :server-items-length="totalGeneticCount"
            :footer-props="{
              'items-per-page-options': itemsPerPageOptions,
              showFirstLastPage: true,
              'items-per-page-text': $t('geneticsAndBreeding.rowsPerPage'),
            }"
            class="custom-table"
            @pagination="paginationChanged"
            hide-default-header
          >
            <template v-slot:header="{ props }">
              <thead class="v-data-table-header">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.value"
                    :style="{ 'min-width': header.width }"
                    class="text-left"
                  >
                    {{ header.text }}
                    <v-tooltip
                      top
                      color="black"
                      max-width="350"
                      v-if="
                        header.text != '' &&
                        header.text != 'Animal Identification'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          style="margin-top: -4px; margin-left: -2px"
                          size="15"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-help-circle-outline</v-icon
                        >
                      </template>
                      <span
                        ><span class="font-weight-bold">{{
                          header.headerTitle
                        }}</span>
                        {{ header.headerDef }}</span
                      >
                    </v-tooltip>
                    <v-icon
                      v-if="
                        header.text != '' &&
                        header.text != 'Animal Identification' &&
                        header.sortable
                      "
                      class="mb-1 ml-1"
                      :class="{
                        'black--text':
                          options.sortBy[0] &&
                          options.sortBy[0] == header.value,
                      }"
                      @click="sortRecords(header)"
                      >mdi-unfold-more-horizontal</v-icon
                    >
                  </th>
                </tr>
              </thead>
            </template>

            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data v-if="GeneticData.length < 1">
              NO RESULT FOUND
            </template>
            <template
              v-if="GeneticData.length > 0"
              v-slot:body="{ items, isSelected, select }"
            >
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <!-- <v-checkbox
                                                @click="()=>{selectUsers(item.id)}"
                                                :value="item.id"
                                            ></v-checkbox> -->
                    <v-checkbox
                      :input-value="isSelected(item)"
                      @click="select(item, !isSelected(item))"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td width="100px">
                    <div class="data-1">
                      <p>
                        Reg #:
                        <v-btn
                          plain
                          elevation="0"
                          style="color: #00bd73; text-decoration: underline"
                          @click="singleResult(item.animalNumber)"
                          >{{ item.registrationNumber }}</v-btn
                        >
                      </p>
                      <p>
                        Name :
                        <span>{{ item.name }}</span>
                      </p>
                      <p>
                        Tag # :
                        <span>{{ item.tagNumber }}</span>
                      </p>
                    </div>
                  </td>
                  <td width="100px">
                    <div class="custom-div">
                      <div class="data-1">
                        <p>
                          Sex : <span>{{ item.gender }}</span>
                        </p>
                        <p>
                          Tattoo :
                          <span>{{ item.tattoo }}</span>
                        </p>
                        <p>
                          DOB : <span>{{ item.birthDate }}</span>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td
                    width="50px"
                    style="white-space: nowrap; padding: 1px 18px !important"
                  >
                    <div style="align-items: end" class="data-1">
                      <p>EPD:</p>
                      <p>Accuracy:</p>
                      <p>% Rank:</p>
                    </div>
                  </td>
                  <td width="75px" class="text-left">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("birth_weight_epd") &&
                      item.birth_weight_epd != null
                        ? Number.isInteger(item.birth_weight_epd)
                          ? item.birth_weight_epd
                          : Number(item.birth_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("birth_weight_accuracy") &&
                      item.birth_weight_accuracy != null
                        ? Number.isInteger(item.birth_weight_accuracy)
                          ? item.birth_weight_accuracy
                          : Number(item.birth_weight_accuracy).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("birth_weight_rank") &&
                      item.birth_weight_rank != null
                        ? Number.isInteger(item.birth_weight_rank)
                          ? item.birth_weight_rank
                          : Number(item.birth_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>

                  <td width="75px" class="text-left">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("weaning_weight_epd") &&
                      item.weaning_weight_epd != null
                        ? Number.isInteger(item.weaning_weight_epd)
                          ? item.weaning_weight_epd
                          : Number(item.weaning_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("weaning_weight_accuracy") &&
                      item.weaning_weight_accuracy != null
                        ? Number.isInteger(item.weaning_weight_accuracy)
                          ? item.weaning_weight_accuracy
                          : Number(item.weaning_weight_accuracy).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("weaning_weight_rank") &&
                      item.weaning_weight_rank != null
                        ? Number.isInteger(item.weaning_weight_rank)
                          ? item.weaning_weight_rank
                          : Number(item.weaning_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td width="75px" class="text-left">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("yearling_weight_epd") &&
                      item.yearling_weight_epd != null
                        ? Number.isInteger(item.yearling_weight_epd)
                          ? item.yearling_weight_epd
                          : Number(item.yearling_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("yearling_weight_accuracy") &&
                      item.yearling_weight_accuracy != null
                        ? Number.isInteger(item.yearling_weight_accuracy)
                          ? item.yearling_weight_accuracy
                          : Number(item.yearling_weight_accuracy).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("yearling_weight_rank") &&
                      item.yearling_weight_rank != null
                        ? Number.isInteger(item.yearling_weight_rank)
                          ? item.yearling_weight_rank
                          : Number(item.yearling_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>

                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("ribEyeArea_epd") &&
                      item.ribEyeArea_epd != null
                        ? Number.isInteger(item.ribEyeArea_epd)
                          ? item.ribEyeArea_epd
                          : Number(item.ribEyeArea_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("ribEyeArea_rank") &&
                      item.ribEyeArea_rank != null
                        ? Number.isInteger(item.ribEyeArea_rank)
                          ? item.ribEyeArea_rank
                          : Number(item.ribEyeArea_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("marbling_epd") &&
                      item.marbling_epd != null
                        ? Number.isInteger(item.marbling_epd)
                          ? item.marbling_epd
                          : Number(item.marbling_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("marbling_rank") &&
                      item.marbling_rank != null
                        ? Number.isInteger(item.marbling_rank)
                          ? item.marbling_rank
                          : Number(item.marbling_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("fatThickness_epd") &&
                      item.fatThickness_epd != null
                        ? Number.isInteger(item.fatThickness_epd)
                          ? item.fatThickness_epd
                          : Number(item.fatThickness_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("fatThickness_rank") &&
                      item.fatThickness_rank != null
                        ? Number.isInteger(item.fatThickness_rank)
                          ? item.fatThickness_rank
                          : Number(item.fatThickness_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("carcass_weight_epd") &&
                      item.carcass_weight_epd != null
                        ? Number.isInteger(item.carcass_weight_epd)
                          ? item.carcass_weight_epd
                          : Number(item.carcass_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("carcass_weight_rank") &&
                      item.carcass_weight_rank != null
                        ? Number.isInteger(item.carcass_weight_rank)
                          ? item.carcass_weight_rank
                          : Number(item.carcass_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>

                    <span v-if="item !== null">{{
                      item.hasOwnProperty("yield_grade_epd") &&
                      item.yield_grade_epd != null
                        ? Number.isInteger(item.yield_grade_epd)
                          ? item.yield_grade_epd
                          : Number(item.yield_grade_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("yield_grade_rank") &&
                      item.yield_grade_rank != null
                        ? Number.isInteger(item.yield_grade_rank)
                          ? item.yield_grade_rank
                          : Number(item.yield_grade_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>

                  <td class="gray2 text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("milk_ability_epd") &&
                      item.milk_ability_epd != null
                        ? Number.isInteger(item.milk_ability_epd)
                          ? item.milk_ability_epd
                          : Number(item.milk_ability_epd).toFixed(2)
                        : "-"
                    }}</span>
                    <br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("milk_ability_accuracy") &&
                      item.milk_ability_accuracy != null
                        ? Number.isInteger(item.milk_ability_accuracy)
                          ? item.milk_ability_accuracy
                          : Number(item.milk_ability_accuracy).toFixed(2)
                        : "-"
                    }}</span>
                    <br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("milk_ability_rank") &&
                      item.milk_ability_rank != null
                        ? Number.isInteger(item.milk_ability_rank)
                          ? item.milk_ability_rank
                          : Number(item.milk_ability_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="gray2 text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("tm") ? item.tm : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("ced") ? item.ced : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("cem") ? item.cem : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("stay") ? item.stay : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("doc") ? item.doc : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                    <!-- <span class="tooltiptext">Coming Soon</span> -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>

          <!-- <v-simple-table class="custom-table">
                            <template v-slot:default>
                            <thead style="background: #FFB443;">
                                <tr>
                                <th class="text-left">
                                </th>
                                <th class="text-left">
                                    Animal Identification
                                </th>
                                <th class="text-left">
                                </th>
                                <th class="text-left">
                                </th>
                                <th class="text-left">
                                    BW
                                </th>
                                <th class="text-left">
                                    WW
                                </th>
                                <th class="text-left">
                                    YW
                                </th>
                                <th class="text-center">
                                    MILK
                                </th>
                                <th class="text-left">
                                    TM
                                </th>
                                <th class="text-left">
                                    CED
                                </th>
                                <th class="text-left">
                                    CEM
                                </th>
                                <th class="text-left">
                                    STAY
                                </th>
                                <th class="text-left">
                                    DOC
                                </th>
                                <th class="text-left">
                                    CW
                                </th>
                                <th class="text-left">
                                    YG
                                </th>
                                <th class="text-left">
                                    REA
                                </th>
                                <th class="text-left">
                                    MS
                                </th>
                                <th class="text-left">
                                    BF
                                </th>
                                </tr>
                            </thead>
                            <tbody v-for="item in GeneticData" :key="item.id" class="tbody-tr tooltip">
                                <tr>
                                    <td style="padding-top: 0px !important;">
                                        <v-checkbox
                                            @click="()=>{selectUsers(item.id)}"
                                            :value="item.id"
                                        ></v-checkbox>
                                    </td>
                                    <td>
                                        
                                        <div class="data-1">
                                            <p>Reg #: <v-btn plain elevation="0" style="color: #00BD73; text-decoration: underline;" @click="singleResult(item.animalNumber)">{{item.registrationNumber}}</v-btn></p> 
                                            <p>Name : <span>{{item.name}}</span></p>
                                            <p>Tag # : <span>{{item.tagNumber}}</span></p>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="custom-div">
                                            <div class="data-1">
                                                <p>Sex : <span>{{item.gender}}</span></p>
                                                <p>Tattoo : <span>{{item.tattoo}}</span></p>
                                                <p>DOB : <span>{{item.dob}}</span></p>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="white-space: nowrap; padding: 1px 18px !important;">
                                        <div style="align-items: end;" class="data-1">
                                            <p>EPD:</p>
                                            <p>Accuracy:</p>
                                            <p>% Rank:</p>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('birth_weight_epd')?Math.round(item.birth_weight_epd):'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                
                                    <td>
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('weaning_weight_epd')? Math.round(item.weaning_weight_epd): '-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td>
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('yearling_weight_epd')?Math.round(item.yearling_weight_epd):'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2 text-center">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('milk')?item.milk:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('tm')?item.tm:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                        
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('ced')?item.ced:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('cem')?item.cem:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('stay')?item.stay:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('doc')?item.doc:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('cw')?item.cw:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('yg')?item.yg:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('rea')?item.rea:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('ms')?item.ms:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    <td class="gray2">
                                        <span v-if="item === null">-</span>
                                        <span v-if="item !== null" >{{item.hasOwnProperty('bf')?item.bf:'-'}}</span><br/>
                                        <span>-</span><br/>
                                        <span>-</span>
                                    </td>
                                    
                                </tr>

                            </tbody>
                            </template>
                        </v-simple-table> -->
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import LoadingMixin from "@/mixins/LoadingMixin";
export default {
  mounted() {
    this.alert = localStorage.getItem("display-alert") != "false";
    this.searchData = localStorage.getItem("searchData");
    this.searchTagData = localStorage.getItem("searchTagData");
    this.searchTagData = JSON.parse(this.searchTagData);
    this.searchData = JSON.parse(this.searchData);
    if (localStorage.getItem("geneticCompareData")) {
      this.selected = JSON.parse(localStorage.getItem("geneticCompareData"));
      localStorage.removeItem("geneticCompareData");
    }

    if (localStorage.getItem("sortGeneticList")) {
      const { sort } = JSON.parse(localStorage.getItem("sortGeneticList"));
      console.log(sort);

      if (sort.sortOrder && sort.sortOrder.toLowerCase() == "desc") {
        this.options.sortDesc[0] = true;
      } else {
        this.options.sortDesc[0] = false;
      }
      if (sort && sort.sortBy) {
        this.sortRecords({ value: sort.sortBy });
      }
    }

    // this.animalGeneticsSearch()
  },
  methods: {
    sortRecords(h) {
      // console.log('header', this.options.sortBy[0], h.value)
      console.log("header", h);
      if (this.options?.sortBy[0] && this.options.sortBy[0] == h.value) {
        this.options.sortDesc[0] = !this.options.sortDesc[0];
      } else {
        this.options.sortBy[0] = h.value;
        this.options.sortDesc[0] = false;
      }
      this.getData();
    },
    alertClosed() {
      localStorage.setItem("display-alert", false);
      this.alert = false;
    },
    async animalGeneticsSearch() {
      if (this.searchData) {
        // this.startLoading();
        this.loading = true;

        const animals = await AnimalService.animalGeneticsSearch(
          this.options,
          this.searchData
        );
        if (animals?.data) {
          const animalResponse = animals.data?.geneticSearchTool;
          this.GeneticData = animalResponse?.rows || [];
          this.totalGeneticData = animalResponse?.fetchedRows;
          this.totalGeneticCount = animalResponse?.count;
          if (this.GeneticData) {
            this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
            this.to =
              this.options.page * this.options.itemsPerPage -
              (this.options.itemsPerPage - animalResponse.fetchedRows);
            this.totalPages = Math.ceil(
              this.totalGeneticCount / this.options.itemsPerPage
            );
          }
          // this.stopLoading();
          this.loading = false;
          console.log(this.GeneticData);
        } else if (animals?.error) {
          this.loading = false;

          console.log(animals?.error);
        }
      }
      if (this.searchTagData) {
        // this.startLoading();
        this.loading = true;
        const animals = await AnimalService.animalGeneticsSearchByReg(
          this.options,
          this.searchTagData
        );
        console.log(animals);
        if (animals?.data) {
          const animalResponse = animals.data?.geneticSearchToolById;
          this.GeneticData = animalResponse?.rows || [];
          this.totalGeneticData = animalResponse?.fetchedRows;
          this.totalGeneticCount = animalResponse?.count;
          if (this.GeneticData) {
            this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
            this.to =
              this.options.page * this.options.itemsPerPage -
              (this.options.itemsPerPage - animalResponse.fetchedRows);
            this.totalPages = Math.ceil(
              this.totalGeneticCount / this.options.itemsPerPage
            );
          }
          // this.stopLoading();
          this.loading = false;
          console.log(this.GeneticData);
        } else if (animals?.errors) {
          this.loading = false;

          console.log(animals?.errors);
        }
      }
    },
    getData() {
      this.animalGeneticsSearch();
    },
    tabletPageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;
      // this.getData()
    },
    paginationChanged() {
      this.$router.replace({ query: { page: this.options.page } });
    },
    selectUsers(id) {
      console.log("selected", this.selected);
      if (this.checkbox.includes(id)) {
        const index = this.checkbox.indexOf(id);
        this.checkbox.splice(index, 1);
        const removeIndex = this.result.findIndex(item => item.id === id);
        this.result.slice(removeIndex, 1);
      } else {
        this.checkbox.push(id);
      }
      this.GeneticData.forEach(val => {
        if (this.checkbox.includes(val.id)) {
          this.result.push(val);
        }
      });
      const uniqueIds = [];
      this.unique = this.result.filter(element => {
        const isDuplicate = uniqueIds.includes(element.id);
        if (!isDuplicate) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      if (this.checkbox.length > 0) {
        this.checkboxx = true;
      } else {
        this.checkboxx = false;
      }
    },
    back() {
      localStorage.removeItem("searchTagData");
      localStorage.removeItem("searchData");
      this.$router.push({ name: "GeneticSearch" });
    },
    openDialog() {
      // let check = this.checkbox
      // var resultt = this.unique.filter(function(element){
      //     return check.some(function(ele){
      //         return element.id === ele;
      //     });
      // })
      if (this.selected.length) {
        localStorage.setItem(
          "geneticCompareData",
          JSON.stringify(this.selected)
        );
        this.$router.push({ name: "GeneticSelectedCompared" });
      } else {
        this.$notify({
          title: "Error",
          text: "Please Select Data To Compare",
          type: "error",
        });
      }
    },
    singleResult(geneticid) {
      console.log(geneticid);
      this.$router.push({ path: `/genetics/epd-info/${geneticid}` });
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    "$route.query": {
      handler(v) {
        if (v?.page) {
          this.options.page = Number(v.page);
        } else {
          this.$router.replace({ query: { page: this.options.page } });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      itemsPerPageOptions: [10, 25, 50, 100, 500],
      selected: [],
      headers: [
        {
          text: this.$t("Animal Identification"),
          align: "start",
          value: "idt",
          class: "text-no-wrap black--text",
          sortable: false,
          width: "100px",
          headerTitle: "",
          headerDef: "",
        },
        {
          text: this.$t(""),
          align: "start",
          value: "no-value",
          class: "text-no-wrap black--text",
          sortable: false,
          width: "100px",
          headerTitle: "",
          headerDef: "",
        },
        {
          text: this.$t(""),
          align: "start",
          value: "no-value2",
          class: "text-no-wrap black--text",
          sortable: false,
          width: "50px",
          headerTitle: "",
          headerDef: "",
        },
        {
          text: this.$t("BW"),
          value: "birth_weight_epd",
          class: "text-no-wrap black--text px-0",
          align: "center",
          sortable: true,
          width: "75x",
          headerTitle: "Birth Weight (BW): ",
          headerDef:
            "Compares the differences in the weight of calves at birth and is measured in pounds or kg.",
        },
        {
          text: this.$t("WW"),
          value: "weaning_weight_epd",
          class: "text-no-wrap black--text",
          align: "center",
          sortable: true,
          width: "75px",
          headerTitle: "Weaning Weight (WW): ",
          headerDef:
            "WW EPD is an estimate of pre-weaning growth that is measured in pounds or kg.",
        },
        {
          text: this.$t("YW"),
          value: "yearling_weight_epd",
          class: "text-no-wrap black--text",
          align: "center",
          sortable: true,
          width: "75px",
          headerTitle: "Yearling Weight (YW): ",
          headerDef:
            "YW EPD is an estimate of post-weaning growth that is measured in pounds or kg.",
        },
        {
          text: this.$t("REA"),
          value: "ribEyeArea_epd",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: true,
          width: "75px",
          headerTitle: "Ribeye Area (REA): ",
          headerDef:
            "REA measures the size of the muscle that gives us the ribeye in square inches.REA EPDs reflect differences in an adjusted 365-day ribeye area measurement based on carcass measurements of harvested cattle.",
        },
        {
          text: this.$t("MARB"),
          value: "marbling_epd",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: true,
          width: "85px",
          headerTitle: "Marbling (MARB): ",
          headerDef:
            "The MARB EPD is in units of percentage of intramuscular fat within the ribeye.MARB EPDs reflect differences in an adjusted 365-day marbling score (intramuscular fat, [IMF]) based on carcass measurements of harvested cattle.",
        },
        {
          text: this.$t("FAT"),
          value: "fatThickness_epd",
          align: "start",
          class: "black--text text-no-wrap px-0",
          sortable: true,
          width: "75px",
          headerTitle: "Fat Thickness (FAT): ",
          headerDef:
            "Inches of backfat (in hundredths of an inch) is the unit of measurement for FT.",
        },
        {
          text: this.$t("CW"),
          value: "carcass_weight_epd",
          align: "center",
          class: "black--text text-no-wrap px-0",
          sortable: true,
          width: "75px",
          headerTitle: "Carcass Weight (CW): ",
          headerDef:
            "Carcass weight is a beneficial trait when considering the impact that pounds have relative to end product value. At the same age constant endpoint, sires with higher values for carcass weight will add more pounds of hot carcass weight compared to sires with lower values for carcass weight.",
        },

        {
          text: this.$t("YG"),
          value: "yield_grade_epd",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: true,
          width: "75px",
          headerTitle: "Yield Grade (YG): ",
          headerDef:
            "The USDA Yield Grade scoring system is the unit of measurement for the YG EPD. Yield Grade 1 are leaner, more retail product carcasses.",
        },
        {
          text: this.$t("MILK"),
          value: "milk",
          class: "text-no-wrap black--text",
          align: "center",
          sortable: false,
          width: "75px",
          headerTitle: "Milk (MK): ",
          headerDef:
            "The MK EPD is measured in pounds of calf weaning weight due to his mother’s milking ability.",
        },
        {
          text: this.$t("TM"),
          value: "tm",
          class: "text-no-wrap black--text",
          sortable: false,
          align: "center",
          width: "75px",
          headerTitle: "Total Maternal (TM): ",
          headerDef:
            "TM measures impact on calf weaning weight due to both milk production and the cow’s genetics for growth.",
        },
        {
          text: this.$t("CED"),
          value: "ced",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "75px",
          headerTitle: "Calving Ease Direct (CED): ",
          headerDef:
            "The CED EPD is listed as a percentage of unassisted calvings.",
        },
        {
          text: this.$t("CEM"),
          value: "cem",
          align: "center",
          class: "black--text text-no-wrap px-0",
          sortable: false,
          width: "77px",
          headerTitle: "Calving Ease Maternal (CEM): ",
          headerDef:
            "Measures the ability of a bull’s daughters to calves unassisted as two year olds.",
        },
        {
          text: this.$t("STAY"),
          value: "stay",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "80px",
          headerTitle: "Stayability (STAY): ",
          headerDef:
            "The ST EPD predicts the ability of a bull to sire cows that “stay around”. The ST EPD is shown as a percentage of how much more likely a bull’s daughters will stay in your herd to the age of 6.",
        },
        {
          text: this.$t("DOC"),
          value: "doc",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "78px",
          headerTitle: "Docility (DOC): ",
          headerDef: "DOC measures the temperament of the cattle.",
        },
      ],
      alert: true,
      geneticIds: [],
      totalGeneticCount: 0,
      searchData1: {},
      searchData2: {},
      searchDataa: null,
      from: 0,
      to: 0,
      totalGeneticData: 0,
      totalPages: 1,
      searchData: {},
      searchTagData: {},
      checkboxx: false,
      checkbox: [],
      result: [],
      results: [],
      unique: [],
      options: { itemsPerPage: 10, page: 1 },
      GeneticData: [],
      loading: false,
    };
  },
  mixins: [LoadingMixin],
  props: ["items", "sort"],
};
</script>
<style lang="scss" scoped>
.custom-t {
  color: #1e1e1e;
  font-family: pop_Bold;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
}
.table-data {
  margin-left: 115px;
  white-space: nowrap;
}
.custom-td {
  display: flex;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

::v-deep .v-icon.v-icon {
  font-size: 18px;
}

::v-deep .custom-table td {
  padding: 18px 1px !important;
}
.custom-table .tbody-tr tr {
  vertical-align: text-top;
}
.custom-table th {
  white-space: nowrap;
}

::v-deep .v-input--selection-controls__ripple {
  border-radius: 50%;
  cursor: pointer;
  height: 0px;
  position: absolute;
  transition: inherit;
  width: 34px;
  left: -12px;
  top: calc(50% - 24px);
  margin: 7px;
}

.colorUnderline {
  color: #00bd73;
  text-decoration: underline;
}

::v-deep .pad {
  padding-left: 10px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 18px 0 0;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.sty {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #1e1e1e;
}
.data-1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-right: 38px;
}
.data-1 p {
  margin: 0px;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
}
.data-1 p span {
  color: #575a5e;
}
.custom-div {
  display: flex;
  justify-content: space-between;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 0px;
  min-width: 64px;
  padding: 0 16px;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
